import React, { useState } from "react";
import { Navbar, Nav, Container, Button } from "react-bootstrap";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";
import {
  FaEnvelope,
  FaHeart,
  FaShoppingCart,
  FaUserCircle,
  FaSignOutAlt,
  FaThLarge,
  FaSignInAlt,
} from "react-icons/fa";
import { toast } from "react-toastify";
import { useAuth } from "../context/AuthContext";
import { useCart } from "../context/CartContext";
import { useWishlist } from "../context/WishlistContext";
import HeaderSearch from "./HeaderSearch";
import "./Header.css";
import Logo from "../assets/logo.png";

const Header = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user, isAuthenticated, logout } = useAuth();
  const { cartCount } = useCart();
  const { wishlistCount } = useWishlist();
  const [expanded, setExpanded] = useState(false);

  const closeNavbar = () => setExpanded(false);

  const navClass = ({ isActive }) =>
    `nav-link${isActive ? " active" : ""}`;

  const shopClass = () => {
    const onShop =
      location.pathname === "/products" ||
      location.pathname.startsWith("/product/");
    return `nav-link${onShop ? " active" : ""}`;
  };

  const handleLogout = async () => {
    await logout();
    toast.success("Logged out");
    closeNavbar();
    navigate("/");
  };

  const accountTitle = (
    <span className="account-dropdown-title">
      <FaUserCircle /> {user?.name?.split(" ")[0] || "Account"}
    </span>
  );

  return (
    <>
      <div className="top-bar">
        <Container>
          <div className="top-bar-content">
            <Link to="/" onClick={closeNavbar}>
              <img src={Logo} alt="SG Office Logo" className="top-logo-img" />
            </Link>

            <HeaderSearch onNavigate={closeNavbar} />

            <div className="top-contact-wrapper">
              <a href="mailto:sales@sgoffice.me" className="top-contact">
                <FaEnvelope className="top-icon" />
                sales@sgoffice.me
              </a>

              {isAuthenticated ? (
                <div className="top-account-info">
                  <Link
                    to="/dashboard"
                    className="top-account-user"
                    onClick={closeNavbar}
                    title="Go to dashboard"
                  >
                    {accountTitle}
                    <span className="account-role-label">{user?.role}</span>
                  </Link>
                  <button
                    type="button"
                    className="top-logout-btn"
                    onClick={handleLogout}
                  >
                    <FaSignOutAlt />
                    <span>Logout</span>
                  </button>
                </div>
              ) : (
                <div className="top-auth-links">
                  <Link to="/login" className="top-login" onClick={closeNavbar}>
                    <FaSignInAlt />
                    <span>Login</span>
                  </Link>
                </div>
              )}
            </div>
          </div>
        </Container>
      </div>

      <Navbar
        expand="lg"
        sticky="top"
        expanded={expanded}
        className="custom-navbar"
      >
        <Container>
          <Navbar.Brand
            as={Link}
            to="/"
            className="brand-text"
            onClick={closeNavbar}
          >
            SG OFFICE
          </Navbar.Brand>

          <Navbar.Toggle
            aria-controls="basic-navbar-nav"
            className="custom-toggle"
            onClick={() => setExpanded(expanded ? false : true)}
          />

          <Navbar.Collapse id="basic-navbar-nav">
            <ul className="navbar-nav mx-auto text-center nav-menu align-items-lg-center">
              <li className="nav-item">
                <NavLink className={navClass} to="/" end onClick={closeNavbar}>
                  Home
                </NavLink>
              </li>

              <li className="nav-item">
                <NavLink className={navClass} to="/about" onClick={closeNavbar}>
                  About Us
                </NavLink>
              </li>

              <li className="nav-item">
                <NavLink
                  className={shopClass}
                  to="/products"
                  onClick={closeNavbar}
                >
                  Shop
                </NavLink>
              </li>

              <li className="nav-item">
                <NavLink
                  className={navClass}
                  to="/sign-graphics"
                  onClick={closeNavbar}
                >
                  Sign & Graphics
                </NavLink>
              </li>

              <li className="nav-item">
                <NavLink
                  className={navClass}
                  to="/catalogue"
                  onClick={closeNavbar}
                >
                  Catalogue
                </NavLink>
              </li>

              <li className="nav-item">
                <NavLink
                  className={navClass}
                  to="/contact"
                  onClick={closeNavbar}
                >
                  Contact Us
                </NavLink>
              </li>

              {isAuthenticated && (
                <li className="nav-item">
                  <NavLink
                    className={({ isActive }) =>
                      `nav-link dashboard-nav-link${isActive ? " active" : ""}`
                    }
                    to="/dashboard"
                    onClick={closeNavbar}
                  >
                    <FaThLarge className="nav-link-icon" /> Dashboard
                  </NavLink>
                </li>
              )}
            </ul>

            <div className="right-menu">
              <Nav.Link
                as={Link}
                to="/wishlist"
                className="header-cart-link"
                onClick={closeNavbar}
              >
                <FaHeart className="nav-icon" />
                {wishlistCount > 0 && (
                  <span className="header-cart-badge">
                    {wishlistCount > 99 ? "99+" : wishlistCount}
                  </span>
                )}
              </Nav.Link>
              <Nav.Link
                as={Link}
                to="/cart"
                className="header-cart-link"
                onClick={closeNavbar}
              >
                <FaShoppingCart className="nav-icon" />
                {cartCount > 0 && (
                  <span className="header-cart-badge">
                    {cartCount > 99 ? "99+" : cartCount}
                  </span>
                )}
              </Nav.Link>
              <Button
                as={Link}
                to="/quote"
                className="quote-btn"
                onClick={closeNavbar}
              >
                Request a Quote
              </Button>
            </div>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </>
  );
};

export default Header;
